import { createFileRoute } from "@tanstack/react-router";

import { VStack } from "@/components/Layout";

import { OperationTasks } from "./-components/content/OperationTasksMain";
import { Header } from "./-components/header/header";

export const Route = createFileRoute("/_staff/cockpit/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <VStack className="justify-center items-center w-full">
      <Header />
      <OperationTasks />
    </VStack>
  );
}
